module.exports = __webpack_public_path__ + "static/media/reshape_black.9102694d.svg";